// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__20Epj","right":"styles_right__1vN1i"};